//土剖面符号svg.js

export function soil(
  g, //在哪个group添加soil
  x, // x坐标
  y, // y坐标
  rotate, // 旋转角度
  scale = 100 //比例
) {
  let soil = g
    .group()
    .addClass("soil")
    .translate(x, y)
    .stroke({ width: 0.25 * scale, color: "white" })
    .rotate(rotate, 0, 0);

  for (let i = 0; i < 3; i++) {
    soil
      .line(0, 0, -3.5 * scale, 3.5 * scale)
      .move(-3.5 * scale - i * 2.2 * scale, 0);
  }
  soil.line(0, 0, 3.5 * scale, 3.5 * scale);
  soil.line(0, 0, 2.3 * scale, 2.3 * scale).move(-1.1 * scale, 1.1 * scale);
  soil.line(0, 0, 1.2 * scale, 1.2 * scale).move(-2.3 * scale, 2.3 * scale);

  return soil;
}
